import Vue from 'vue'
import VueRouter from 'vue-router'
import Product from '../views/Product.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/checkout',
		name: 'checkout',
		component: () => import('../views/Checkout.vue')
	},
	{
		path: '/shipping',
		name: 'shipping',
		component: () => import('../views/Shipping.vue')
	},
	{
		path: '/payment',
		name: 'payment',
		component: () => import('../views/Payment.vue')
	},
	{
		path: '/:slug',
		name: 'home',
		component: Product
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
